import React, { useEffect, useState } from 'react';
import Styles from './index.less';
import { CustomNumberInput } from '@framework/workbench/common/components/custom-number-input';
import { NumberInputFrom } from '@com/property-editor/editor-components/number-input-new';

interface ITransitionDurationInputProps {
    icon: string;
    text: string;
    value: number;
    onBlur?: () => {}
    onValueChange: (val: number, form?: NumberInputFrom) => void;
}

const minDuration = 0.01;
const maxDuration = 24 * 3600;

export default function TransitionDurationInput(props: ITransitionDurationInputProps) {
    const { icon, text, value } = props;
    const [duration, setDuration] = useState(value);

    useEffect(() => {
        setDuration(value);
    }, [value]);

    return <div className={Styles['transition-duration-input-container']}>
        <div className={Styles['transition-duration-title-container']}>
            <img className={Styles['transition-duration-icon']} src={icon}/>
            <div className={Styles['transition-duration-text']}>{text}</div>
        </div>
        <CustomNumberInput
            onChange={(val, form) => {
                const value = parseFloat(val);
                const validDurationValue = getValidDurationValue(value);

                setDuration(validDurationValue);
                props.onValueChange(validDurationValue, form);
            }}
            width={76}
            value={duration}
            toFixed={2}
            step={0.25}
            min={minDuration}
            max={maxDuration}
            allowDecimal={true}
            suffix={'s'}
        />
    </div>;
}

function getValidDurationValue(value: any) {
    if (isNaN(value) || value < minDuration) return minDuration;
    if (value > maxDuration) return maxDuration;
    return value;
}
